module.exports = function ($location, pageMetaDataService) {
    this.metaData = pageMetaDataService;

    this.currentUrl = function () {
        return $location.absUrl();
    };
};



// WEBPACK FOOTER //
// ./src/common/pagemetadata/page-metadata-controller.js